import { captureCustomException } from 'App/Services/ErrorTracking/captureCustomException';

import { ONESIGNAL_INCORRECT_DEVICE_ID_ERROR } from './constants';

/**
 * Returns the OneSignal player id after a granted opt-in. Reports when the
 * SDK returns a missing or local placeholder id.
 *
 * @param {Object} event - OneSignal PushSubscription `change` event.
 * @returns {string|null}
 */
export const getOptedInDeviceId = (event) => {
    if (!event?.current?.optedIn) return null;

    const deviceId = event.current.id;

    if (deviceId && !deviceId.includes('local')) {
        return deviceId;
    }

    captureCustomException(
        new Error('Incorrect Device Id'),
        ONESIGNAL_INCORRECT_DEVICE_ID_ERROR,
        { osd_id: deviceId }
    );

    return null;
};
